import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from './../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { saloon1ImageOptions } from './views/saloon1'

class X46Saloon extends Component {
    constructor(props) {
        super(props);
        this.handleCupboardsSaloonChange = this.handleCupboardsSaloonChange.bind(this);
        this.handleTableBoxChange = this.handleTableBoxChange.bind(this);
        this.handlePouffesChange = this.handlePouffesChange.bind(this);
        this.handleBackrestChange = this.handleBackrestChange.bind(this);
    }


    handleCupboardsSaloonChange(event) {
        let configuration = this.props.configuration;
        configuration.CupboardsSaloon = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTableBoxChange(event) {
        let configuration = this.props.configuration;
        configuration.TableBox = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handlePouffesChange(event) {
        let configuration = this.props.configuration;
        configuration.Pouffes = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBackrestChange(event) {
        let configuration = this.props.configuration;
        configuration.Backrest = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = saloon1ImageOptions;

        let image = <ConfiguratorImage boat="X4_6" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Saloon' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='You can choose to have extra storage space by adding upper cupboards in the saloon, a luxury table inclusive bottle box and exclusive table top surface, a pouffe for extra seats at the table and back rest cushions on the leafs of the sofa.' /></p>
                    <p><Trans defaults='On this image, the cabin is shown with ambient lighting fitted in hull deck joint – and if optional upper cupboards are selected, the lighting is fitted below the cupboards.' /></p>

                    <Toggle checked={this.props.configuration.CupboardsSaloon.value === 2} onChange={this.handleCupboardsSaloonChange}>
                        <Trans defaults='Upper cupboards' />
                    </Toggle>


                    <Toggle checked={this.props.configuration.TableBox.value === 2} onChange={this.handleTableBoxChange}>
                        <Trans defaults='Table box' />
                    </Toggle>


                    <Toggle checked={this.props.configuration.Pouffes.value === 2} onChange={this.handlePouffesChange}>
                        <Trans defaults='Pouffe' />
                    </Toggle>


                    <Toggle checked={this.props.configuration.Backrest.value === 2} onChange={this.handleBackrestChange}>
                        <Trans defaults='Back rest cushions' />
                    </Toggle>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X46Saloon);


// WEBPACK FOOTER //
// ./src/X46/X46Saloon.js